/**
 * Skylab API — Ask Skylab (stub this phase).
 *
 * POST /internal/skylab/ask
 *
 * Super-admin-only. Single-turn question/answer surface in the Skylab Insights
 * tab. Plan U5 / Decision 7: the endpoint contract is real (input validation,
 * shape, status codes), but the implementation is a STUB that returns a
 * hard-coded placeholder string. No model is called. No Anthropic SDK is
 * imported. When real LLM integration lands (separate plan), only the backend
 * `ask-stub.ts` swaps to a real implementation — this contract does not change.
 *
 * Type names are prefixed `SkylabAsk*` because the root shared-types barrel
 * re-exports every `api/*` module with `export *`; the prefix avoids collisions.
 */

import { z } from 'zod'

/** Soft cap on a single question. Mirrors the backend schema. */
export const SKYLAB_ASK_MAX_QUESTION_LENGTH = 1000

export const SkylabAskRequestSchema = z.object({
  /** School public id the question is scoped to (active school in the UI). */
  schoolId: z.string().min(1),
  /** The user's question. Trimmed, non-empty, capped at 1000 chars. */
  question: z.string().trim().min(1).max(SKYLAB_ASK_MAX_QUESTION_LENGTH)
})
export type SkylabAskRequest = z.infer<typeof SkylabAskRequestSchema>

export const SkylabAskResponseSchema = z.object({
  /** Placeholder string this phase; will become a real model answer later. */
  answer: z.string(),
  /** True while the endpoint is the stub. Lets UI render a "not wired" hint. */
  stub: z.literal(true)
})
export type SkylabAskResponse = z.infer<typeof SkylabAskResponseSchema>
